import { render, staticRenderFns } from "./StreamlitDashboard.vue?vue&type=template&id=37ff34d0&scoped=true&"
import script from "./StreamlitDashboard.vue?vue&type=script&lang=js&"
export * from "./StreamlitDashboard.vue?vue&type=script&lang=js&"
import style0 from "./StreamlitDashboard.vue?vue&type=style&index=0&id=37ff34d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ff34d0",
  null
  
)

export default component.exports